const AsyncStorage = localStorage;
export const storeData = async (item, value) => {
  try {
    await AsyncStorage.setItem(item, value);
  } catch (e) {
    console.error(e);
  }
};

export const storeJsonData = async (item, value) => {
  try {
    await AsyncStorage.setItem(item, JSON.stringify(value));
  } catch (e) {
    console.error(e);
  }
};

export const getJsonData = async (item) => {
  try {
    const jsonValue = await AsyncStorage.getItem(item);
    return jsonValue != null ? JSON.parse(jsonValue) : null;
  } catch (e) {
    console.error("storage error", e);
    return null;
  }
};
export const getData = async (item) => {
  try {
    const value = await AsyncStorage.getItem(item);
    return value;
  } catch (e) {
    // error reading value
    console.error("storage error", e);
    return null;
  }
};

export const remove = async (item) => {
  try {
    await AsyncStorage.removeItem(item);
  } catch (e) {
    console.error(" remove storage error", e);
  }
};
